module.exports = __webpack_public_path__ + "static/media/6b310c04-027c-4040-bb37-c701f399abf8.56a27f8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/competence/6b310c04-027c-4040-bb37-c701f399abf8.png
// module id = 1459
// module chunks = 0